"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = require("react");

function useResizeObserver(ref) {
  const [boxSize, setBoxSize] = (0, react_1.useState)({
    contentBoxSize: {},
    borderBoxSize: {},
    contentRect: {}
  });
  (0, react_1.useEffect)(() => {
    if (!ref.current) {
      return;
    }

    const handleResize = entries => {
      const [entry] = entries;
      const {
        contentRect
      } = entry;
      const contentBoxSize = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;
      const borderBoxSize = Array.isArray(entry.borderBoxSize) ? entry.borderBoxSize[0] : entry.borderBoxSize;
      setBoxSize({
        contentBoxSize,
        borderBoxSize,
        contentRect
      });
    };

    const observer = new ResizeObserver(handleResize);
    observer.observe(ref.current);
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
        return;
      }

      observer.disconnect();
    };
  }, [ref]);
  return boxSize;
}

exports.default = useResizeObserver;